import type {
  DeviceLinkClaimRequest,
  DeviceLinkClaimResponse,
  DeviceLinkSuggestionItem,
  DeviceLinkSuggestionResponse,
  Item,
} from "@generated/n3-backend-api";
import IdentityObject from "@/src/domain/common/identity-object";

export type PropertyProfile = "TENANT_RENTER" | "OWNER_OCCUPIER" | "LANDLORD_PROPERTY_MANAGER";

export const isLandlordPropertyProfile = (propertyProfile?: string | null) =>
  propertyProfile === "LANDLORD_PROPERTY_MANAGER";

export type DeviceLinkSuggestion = DeviceLinkSuggestionItem;
export type { DeviceLinkClaimRequest, DeviceLinkClaimResponse, DeviceLinkSuggestionResponse };

export default abstract class DeviceService extends IdentityObject {
  abstract fetchAllDevices(): Promise<Item[]>;
  abstract fetchDeviceById(id: number): Promise<Item>;
  abstract fetchDeviceLinkSuggestions(): Promise<DeviceLinkSuggestionResponse>;
  abstract claimDeviceLinks(request: DeviceLinkClaimRequest): Promise<DeviceLinkClaimResponse>;
  abstract updateDevicePropertyProfile(id: number, propertyProfile: PropertyProfile): Promise<void>;
}
